const disableFields = (value, fields) => {
  if (!fields) return;

  Array.from(fields)?.forEach((el) => {

    if (value === 'yes') {
      el.removeAttribute('disabled');
      el.setAttribute('required', el.initialValue);
      el?.parentElement?.classList.remove('hidden');
    } else {
      el?.parentElement?.classList.add('hidden');
      el.setAttribute('disabled', 'true');
      el.setAttribute('required', 'false');
    }
  });
};

const queryRelatedFields = (input) => {
  const relatedFieldsIds = input.getAttribute('disableForIds');
  const query = relatedFieldsIds?.split(',')?.map((item) => `#${item}`).join(',');
  if (query) return document.querySelectorAll(query);
};

const storeInitialValues = (fields) => {
  Array.from(fields)?.forEach((el) => {
    el.initialValue = el.getAttribute('required');
  });
};

export const switchHandler = (sw, cb = null) => {

  if (!sw) return;

  const switchInput = sw.querySelector('input');
  const switchButton = sw.querySelector('.switch');

  if (!switchInput || !switchButton) return;

  let initialValue = Boolean(switchInput.hasAttribute('checked'));
  const relatedFields = queryRelatedFields(switchInput);
  storeInitialValues(relatedFields);
  switchInput.value = initialValue ? 'yes' : 'no';
  disableFields(switchInput.value, relatedFields);

  const onSwitch = () => {
    initialValue = !initialValue;
    initialValue ? switchInput.setAttribute('checked', '') : switchInput.removeAttribute('checked');
    switchButton.setAttribute('aria-label', `${initialValue ? 'YES' : 'NO'} selected`);
    switchInput.value = initialValue ? 'yes' : 'no';
    disableFields(switchInput.value, relatedFields);

    cb?.(initialValue);
  };

  switchInput.addEventListener('click', onSwitch);

  switchButton.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === '') {
      onSwitch();
    }
  });
};
